import { AgGridReact } from 'ag-grid-react'; // React Data Grid Component
import 'ag-grid-community/styles/ag-grid.css'; // Mandatory CSS required by the Data Grid
import 'ag-grid-community/styles/ag-theme-quartz.css'; // Optional Theme applied to the Data Grid
import { useEffect } from 'react';
import { StatisticsGridConfig } from '../config/StatisticsGridConfig';
import 'ag-grid-enterprise';
import { useStatistics } from '../hooks/useStatistics';

export const Statistics = () => {
    const {
        records,
        getRowStyle,
        context,
        onGridReady,
        getRecord,
        getBatchIpLocations
    } = useStatistics();

    // eslint-disable-next-line
    useEffect(getRecord, []);

    // eslint-disable-next-line
    useEffect(getBatchIpLocations, [records]);

    return (
        <div>
            <h2>{'Statistics'}</h2>
            <div
                className={'ag-theme-quartz'} // applying the Data Grid theme
                style={{ height: 1000, margin: 20 }} // the Data Grid will fill the size of the parent container
            >
                <AgGridReact
                    rowData={records}
                    getRowStyle={getRowStyle}
                    context={context}
                    onGridReady={onGridReady}
                    columnDefs={StatisticsGridConfig.columnDefs}
                />
            </div>
        </div>
    );
};